import styled, { keyframes } from 'styled-components'

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
`

const animation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

const Spinner = styled.div`
  display: inline-block;
  width: 80px;
  height: 80px;

  &:after {
    content: ' ';
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid var(--color-primary);
    border-color: var(--color-primary) transparent var(--color-primary) transparent;
    animation: ${animation} 1.2s linear infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    &:after {
      animation: none;
      border-color: var(--color-primary);
    }
  }
`

const ScreenReaderText = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

const ScreenLoader = () => {
  return (
    <Box className='spinner' role="status" aria-live="polite">
      <Spinner aria-hidden="true" />
      <ScreenReaderText>Loading...</ScreenReaderText>
    </Box>
  )
}

export default ScreenLoader
